<template>
    <activix-helper-notification :title="title" :description="description" ref="notification">
        <template #avatar>
            <div
                class="h-12 w-12 rounded-full shadow-md bg-grey-500 flex items-center justify-center"
            >
                <icon class="text-white text-2xl" :name="leadIcon" />
            </div>
        </template>
        <template #buttons>
            <activix-button
                class="leading-5"
                type="primary"
                tag="router-link"
                :to="leadLink"
                @click="close"
            >
                {{ $t('screenPop.goToLead') }}
            </activix-button>
            <activix-button class="leading-5" @click="close">
                {{ $t('screenPop.dismiss') }}
            </activix-button>
        </template>
    </activix-helper-notification>
</template>

<script>
    import { mapActions } from 'pinia';
    import { useEventBus } from '@/hooks/useEventBus.ts';
    import Lead from '../../entities/Lead.js';
    import LeadPhone from '../../entities/LeadPhone.js';
    import { useGlobalStore } from '../../store/store.ts';

    const { on, off } = useEventBus();

    export default {
        data: () => ({
            type: 'incomingCall',
            opened: false,
            lead: new Lead(),
        }),

        computed: {
            title() {
                if (this.type == 'webBoost') {
                    return this.$t('screenPop.call.title.webBoost');
                }

                return this.$t('screenPop.call.title.incomingCall');
            },

            description() {
                const firstPhone = new LeadPhone(this.lead.lead_phones[0]);

                return this.$t('screenPop.call.description', [
                    this.lead.fullName || firstPhone.toString() || this.$t('general.unknown'),
                ]);
            },

            leadLink() {
                return {
                    name: 'leads.update',
                    params: { id: this.lead.id },
                };
            },

            leadIcon() {
                return this.getLeadTypeIcon(this.lead);
            },
        },

        methods: {
            ...mapActions(useGlobalStore, ['fetchLead']),

            async open(payload) {
                const { leadId, type } = payload || {};
                this.lead = await this.fetchLead(leadId);
                this.type = type;
                this.$refs.notification.open();
            },

            close() {
                this.$refs.notification.close();

                this.$nextTick(() => {
                    this.$reset();
                });
            },
        },

        created() {
            on('screen-pop-open', this.open);
            on('screen-pop-close', this.close);
        },

        beforeUnmount() {
            off('screen-pop-open', this.open);
            off('screen-pop-close', this.close);
        },
    };
</script>
